import {
  Accordion as MuiAccordion,
  AccordionSummary as MuiAccordionSummary,
  AccordionDetails as MuiAccordionDetails,
  IconButton,
} from "@mui/material";
import { styled } from "@mui/system";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";

// Base Accordion component
const BaseAccordion = ({
  expanded,
  onChange,
  theme,
  borderColor,
  ...props
}) => (
  <MuiAccordion
    expanded={expanded}
    onChange={onChange}
    disableGutters
    elevation={2}
    square
    {...props}
  />
);

// Styled Accordion component
const Accordion = styled(BaseAccordion)(({ theme, borderColor }) => ({
  border: `2px solid ${borderColor || theme.palette.divider}`,
  "&:not(:last-child)": {
    //borderBottom: 0,
  },
  "&:before": {
    display: "none",
  },
}));

// Base AccordionSummary component
const BaseAccordionSummary = ({ theme, color, ...props }) => (
  <MuiAccordionSummary {...props} />
);

// Styled AccordionSummary component
const AccordionSummary = styled(BaseAccordionSummary)(({ theme }) => ({
  flexDirection: "row",
  justifyContent: "space-between",
  "& .MuiAccordionSummary-content": {
    marginRight: theme.spacing(1),
  },
}));

// Function to render expand/collapse button based on expanded state
const ExpandButton = ({ expanded, ...props }) => (
  <IconButton
    sx={{
      backgroundColor: "white",
      borderRadius: "50%",
      width: "30px",
      height: "30px",
      "&:hover": {
        backgroundColor: "rgba(255, 255, 255, 0.8)",
      },
    }}
    {...props}
  >
    <ArrowForwardIosSharpIcon sx={{ fontSize: "small", fontWeight: "bold" }} />
  </IconButton>
);

// Modified AccordionSummary component with expand/collapse button
const CustomAccordionSummary = ({ expanded, ...props }) => (
  <AccordionSummary
    expandIcon={<ExpandButton expanded={expanded} />} // Pass expanded state here
    {...props}
  />
);

// Styled AccordionDetails component
const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: "0px !important",
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

export {
  Accordion,
  CustomAccordionSummary as AccordionSummary,
  AccordionDetails,
};
